import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import classnames from "classnames";
import { TITLE_TYPE } from "components/core/short-footer/short-footer-service";
import PictureComponent from "components/core/picture/picture-component";
import { StyledShortFooterLink } from "./short-footer-link.scss";
const LINK_TYPE_TO_CLASS_NAME = {
    [TITLE_TYPE.MAIN]: "main-title",
    [TITLE_TYPE.MAIN_CLICKABLE]: "main-title clickable",
    [TITLE_TYPE.SECONDARY]: "secondary-title",
    [TITLE_TYPE.LINK]: "link"
};
class ShortFooterLink extends PureComponent {
    render() {
        const { title, url, translate, type, icon, rightSideIcon, hasBetaTag } = this.props;
        return /*#__PURE__*/ _jsxs(StyledShortFooterLink, {
            className: classnames("short-footer-link-component", LINK_TYPE_TO_CLASS_NAME[type]),
            href: url,
            children: [
                icon && /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "link-icon",
                    src: icon,
                    alt: translate(title)
                }),
                translate(title),
                rightSideIcon && /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "link-icon",
                    src: rightSideIcon,
                    alt: translate(title)
                }),
                hasBetaTag && /*#__PURE__*/ _jsx("div", {
                    className: "beta-tag",
                    children: translate("header.tabs.solutions.byProduct.dev.beta")
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export default withGenericConfig(ShortFooterLink);
